import { render } from "./replies-item.vue?vue&type=template&id=179c6318&scoped=true&ts=true"
import script from "./replies-item.vue?vue&type=script&lang=ts"
export * from "./replies-item.vue?vue&type=script&lang=ts"

import "./replies-item.vue?vue&type=style&index=0&id=179c6318&lang=scss&scoped=true"

import exportComponent from "/Users/ls/Documents/维思英才/webchat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-179c6318"]])

export default __exports__